export const contentItems = [
  {
    id: "plot-chapter-01",
    type: "plot",
    title: "第1集 · 归乡的列车",
    subtitle: "第1集",
    chapter: 1,
    summary:
      "离开故乡七年的林静书带着年幼的女儿重返小城。熟悉的街道与陌生的目光交织，一场关于回归与重新开始的故事就此展开。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20warm%20train%20window%20view%20of%20small%20town%20dusk%20soft%20golden%20light%20melancholic%20mood%20film%20still%20warm%20neutral%20tones%20shallow%20depth%20of%20field&width=1200&height=800&seq=mother3-plot-01&orientation=landscape",
    date: "2026-09-01",
    tags: ["开篇", "归乡", "命运转折"],
    sections: [
      {
        heading: "剧情梗概",
        paragraphs: [
          "故事从一个深秋的清晨开始。林静书牵着女儿的手走下那趟穿透薄雾的绿皮火车，七年前她正是从这里离开的。小城的一切似乎都没变，早点铺的蒸汽、巷口的老槐树、还有站台上那块褪色的指示牌，可她却觉得每一样东西都在提醒她：你已经不是当年那个十九岁的女孩了。",
          "回到老宅的第一晚并不平静。母亲留下的旧相册被翻了出来，一张拍摄于多年前的全家福让静书久久沉默。女儿小声问她照片里的男人是谁，她只是笑着把相册合上，说那是很久以前的事了。",
        ],
      },
      {
        heading: "本集看点",
        paragraphs: [
          "本集用大量的环境镜头交代了故事的发生地，也埋下了关于静书过去的第一个悬念。她为什么离开，又为什么回来，成为贯穿全剧的第一条主线。",
          "女儿与静书之间那种既依赖又小心翼翼的关系，也在本集中被细腻地呈现出来，为后续的母女情感线打下基础。",
        ],
      },
    ],
  },
  {
    id: "plot-chapter-02",
    type: "plot",
    title: "第2集 · 陌生人的来信",
    subtitle: "第2集",
    chapter: 2,
    summary:
      "一封没有署名的信被塞进老宅的门缝，信中提到的往事让静书不得不重新面对那段被刻意遗忘的记忆。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20close%20up%20of%20old%20handwritten%20letter%20on%20wooden%20table%20soft%20window%20light%20warm%20tones%20mysterious%20quiet%20atmosphere%20film%20still&width=1200&height=800&seq=mother3-plot-02&orientation=landscape",
    date: "2026-09-03",
    tags: ["悬念", "往事", "书信"],
    sections: [
      {
        heading: "剧情梗概",
        paragraphs: [
          "整理老宅的时候，静书在门缝里发现了一封没有署名的信。信纸泛黄，字迹工整，只写了一句话：有些事你以为过去了，其实它一直在等你回来。",
          "这封信像一颗石子投进平静的水面。静书开始翻找母亲留下的遗物，试图拼凑出那段模糊的过往。与此同时，邻居们的议论也渐渐传入她的耳中，小镇看似温和的表面下，藏着许多没有说出口的故事。",
        ],
      },
      {
        heading: "本集看点",
        paragraphs: [
          "本集开始引入外部视角，小镇居民的只言片语让静书的过去变得愈发扑朔迷离，也让观众对她的处境产生更深的共情。",
          "结尾处静书在雨中对着一封旧信出神的画面，成为全剧极具代表性的一个镜头。",
        ],
      },
    ],
  },
  {
    id: "plot-chapter-03",
    type: "plot",
    title: "第3集 · 旧照片里的秘密",
    subtitle: "第3集",
    chapter: 3,
    summary:
      "一张被藏在相册夹层里的旧照片，让静书发现母亲生前瞒着她做了许多事。真相的一角被掀开，也让她第一次动摇。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20vintage%20photo%20album%20open%20on%20table%20with%20scattered%20old%20photographs%20warm%20amber%20light%20nostalgic%20intimate%20film%20still&width=1200&height=800&seq=mother3-plot-03&orientation=landscape",
    date: "2026-09-05",
    tags: ["真相", "母亲", "亲情"],
    sections: [
      {
        heading: "剧情梗概",
        paragraphs: [
          "在整理相册时，静书意外发现夹层里藏着一张陌生男人的照片，背面写着一个日期和一句未完成的话。这个发现让她对母亲的理解彻底改变。",
          "她带着照片四处打听，却屡屡碰壁。直到在小城的旧书店里，一位年迈的店主认出了照片上的人，故事的另一条支线由此浮出水面。",
        ],
      },
      {
        heading: "本集看点",
        paragraphs: [
          "本集是全剧第一个重要的信息转折点，母亲的形象从“温和的守护者”变得复杂而立体的角色。",
          "静书与女儿在旧书店的一段对话，用最简单的方式点出了整部剧关于“理解”与“原谅”的主题。",
        ],
      },
    ],
  },
  {
    id: "plot-chapter-04",
    type: "plot",
    title: "第4集 · 雨夜的抉择",
    subtitle: "第4集",
    chapter: 4,
    summary:
      "一场突如其来的暴雨困住了静书与东勋。多年未见的两人在屋檐下说出了各自这些年的心事，也迎来了第一个重要的选择。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20rainy%20night%20two%20figures%20under%20a%20narrow%20eaves%20warm%20street%20lamp%20reflections%20on%20wet%20pavement%20emotional%20restrained%20mood%20film%20still&width=1200&height=800&seq=mother3-plot-04&orientation=landscape",
    date: "2026-09-08",
    tags: ["抉择", "重逢", "雨夜"],
    sections: [
      {
        heading: "剧情梗概",
        paragraphs: [
          "暴雨让小镇陷入短暂的停顿。静书在回家的路上遇见了多年未见的姜东勋，两个人在一家小店的屋檐下躲雨，从尴尬的寒暄慢慢聊到了各自的生活。",
          "东勋说出了当年没能说出口的话，而静书也在这一刻意识到，她回来或许并不只是为了整理母亲留下的房子。雨停之后，两个人都做出了各自的第一步选择。",
        ],
      },
      {
        heading: "本集看点",
        paragraphs: [
          "本集是全剧情感节奏最集中的一集，大量留白与长镜头让观众沉浸在雨夜的氛围里。",
          "“有些话等到雨停了就不用说了”——这句台词播出后成为观众讨论度最高的金句。",
        ],
      },
    ],
  },
  {
    id: "plot-chapter-05",
    type: "plot",
    title: "第5集 · 餐桌上的沉默",
    subtitle: "第5集",
    chapter: 5,
    summary:
      "一封家宴邀请把所有人重新聚到同一张餐桌前。表面平静的饭局之下，多年积累的误会与情绪终于有了松动的迹象。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20family%20dinner%20table%20warm%20indoor%20lamplight%20several%20almost%20silent%20people%20restrained%20emotion%20muted%20warm%20tones%20film%20still&width=1200&height=800&seq=mother3-plot-05&orientation=landscape",
    date: "2026-09-11",
    tags: ["群像", "家宴", "和解前奏"],
    sections: [
      {
        heading: "剧情梗概",
        paragraphs: [
          "一场为长辈举办的家宴，让分散多年的家人重新围坐在一起。菜肴丰盛，话却不多，每个人都带着各自的心事。",
          "席间的一句无心之言点燃了积压已久的情绪。争吵过后，反倒是沉默让彼此第一次认真看见了对方。这一集没有给出答案，却让所有关系都向前挪动了一小步。",
        ],
      },
      {
        heading: "本集看点",
        paragraphs: [
          "群像戏是本集的核心，五位主要角色在同一场戏中各自完成了情绪弧线的小转折。",
          "导演用大量静默的空镜和餐具特写替代对白，把“说不出的话”变成了可以看见的画面。",
        ],
      },
    ],
  },
  {
    id: "plot-chapter-06",
    type: "plot",
    title: "第6集 · 天台上的告白",
    subtitle: "第6集",
    chapter: 6,
    summary:
      "在对全剧意义重大的天台上，静书终于向女儿说出了一直藏在心里的话，也向自己交出了答案。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20rooftop%20at%20dusk%20city%20silhouette%20mother%20and%20daughter%20standing%20together%20warm%20orange%20sky%20hopeful%20emotional%20film%20still&width=1200&height=800&seq=mother3-plot-06&orientation=landscape",
    date: "2026-09-14",
    tags: ["高潮", "母女", "释怀"],
    sections: [
      {
        heading: "剧情梗概",
        paragraphs: [
          "静书带着女儿爬上老宅的天台，那里曾经是她年轻时最爱去的地方。城市的灯火一盏盏亮起，她第一次完整地讲出了自己的过去。",
          "女儿没有哭，只是静静地听完，然后握住了她的手。这一场天台上的告白，既是母亲对女儿的交代，也是静书与过去的和解。",
        ],
      },
      {
        heading: "本集看点",
        paragraphs: [
          "作为全剧情感高潮的一集，本集几乎没有配乐，完全依靠表演与自然声推进，感染力极强。",
          "结尾的远景镜头把人物的情绪交给整座城市来承接，被视为整部剧最具诗意的收束。",
        ],
      },
    ],
  },
  {
    id: "character-lin-jingshu",
    type: "character",
    title: "林静书 · 领衔主演",
    subtitle: "林静书",
    role: "领衔主演",
    summary:
      "全剧核心人物。三十出头的她带着女儿回到故乡，用看似温和的方式对抗着生活留下的伤口，是全剧情感与主题的承载者。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20calm%20woman%20in%20her%20thirties%20soft%20window%20light%20warm%20neutral%20tones%20gentle%20restrained%20expression%20film%20still%20portrait&width=900&height=1200&seq=mother3-char-01&orientation=portrait",
    date: "2026-09-02",
    tags: ["主角", "母亲", "成长"],
    sections: [
      {
        heading: "人物设定",
        paragraphs: [
          "林静书是这个故事绝对的核心。她并非传统意义上温柔隐忍的母亲形象，而是一个会在深夜独自崩溃、又在清晨重新整装出发的真实女性。",
          "她回到故乡的动机并不单纯，既有对母亲离世的愧疚，也有想要给女儿一个安稳生活的期待。正是这种复杂性，让她成为观众最能代入的角色。",
        ],
      },
      {
        heading: "角色弧线",
        paragraphs: [
          "从最初的回避与沉默，到后来主动去揭开往事，再到最终在天台上完成与自我的和解，静书的成长贯穿全剧。",
          "她身上最动人的地方，在于她始终没有变成一个完美的人，却始终在努力成为一个更好的人。",
        ],
      },
    ],
  },
  {
    id: "character-jiang-dongxun",
    type: "character",
    title: "姜东勋 · 主线人物",
    subtitle: "姜东勋",
    role: "主线人物",
    summary:
      "与静书有着共同过去的男人。多年后重逢，他选择用最克制的方式守护，是全剧情感线中最让人心疼的存在。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20quiet%20man%20in%20his%20thirties%20warm%20evening%20light%20muted%20earth%20tones%20thoughtful%20expression%20film%20still%20portrait&width=900&height=1200&seq=mother3-char-02&orientation=portrait",
    date: "2026-09-04",
    tags: ["情感线", "守护", "克制"],
    sections: [
      {
        heading: "人物设定",
        paragraphs: [
          "东勋是那种把所有心事都藏在行动里的人。他不善言辞，却总在静书最需要的时候出现。",
          "他留在小城的这些年，一直过着平淡的生活，直到静书回来，那些被搁置的情感才重新有了重量。",
        ],
      },
      {
        heading: "人物关系",
        paragraphs: [
          "他与静书之间的情感是一种“未完成”。两个人都在意对方，却又都因为过去而不敢轻易靠近。",
          "东勋与静书女儿之间那种自然的亲近，也让这段关系多了一层温暖的可能。",
        ],
      },
    ],
  },
  {
    id: "character-su-yiran",
    type: "character",
    title: "苏怡然 · 亲情线",
    subtitle: "苏怡然",
    role: "亲情线",
    summary:
      "静书的妹妹，性格直率、说话不留情面，却也是家里最先站出来支持姐姐的人。姐妹关系的修复是全剧重要支线。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20bright%20young%20woman%20with%20direct%20gaze%20soft%20daylight%20warm%20clean%20neutral%20tones%20film%20still%20portrait&width=900&height=1200&seq=mother3-char-03&orientation=portrait",
    date: "2026-09-06",
    tags: ["亲情线", "姐妹", "直率"],
    sections: [
      {
        heading: "人物设定",
        paragraphs: [
          "怡然和姐姐的性格截然相反。她想到什么就说什么，早年因为姐姐的离开而心怀芥蒂，嘴上从不饶人。",
          "但正是这样一个人，在关键时刻从来不会缺席。她的锋利之下，藏着对家人最深的在意。",
        ],
      },
      {
        heading: "人物关系",
        paragraphs: [
          "姐妹二人之间从对抗到理解的转变，是全剧最真实的亲情写照。第5集家宴上的那场争执，是这段关系的重要转折。",
        ],
      },
    ],
  },
  {
    id: "character-han-meilan",
    type: "character",
    title: "韩美兰 · 亲情线",
    subtitle: "韩美兰",
    role: "亲情线",
    summary:
      "静书的婆婆。表面严厉古板，实则背负着整个家庭的秘密。她的沉默是剧中最沉重也最动人的部分之一。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20an%20elderly%20elegant%20woman%20with%20calm%20dignified%20face%20soft%20warm%20indoor%20light%20muted%20neutral%20tones%20film%20still%20portrait&width=900&height=1200&seq=mother3-char-04&orientation=portrait",
    date: "2026-09-07",
    tags: ["亲情线", "长辈", "秘密"],
    sections: [
      {
        heading: "人物设定",
        paragraphs: [
          "美兰是那种把“规矩”挂在嘴边的人，对静书的回来始终保持距离。但她的严格并非冷漠，而是被岁月磨出来的自我保护。",
          "随着往事被一层层揭开，她才是那个把秘密守得最久、也伤得最深的人。",
        ],
      },
      {
        heading: "人物关系",
        paragraphs: [
          "她与静书之间的婆媳关系，从互相试探到彼此托付，构成了全剧另一条重要的情感脉络。",
        ],
      },
    ],
  },
  {
    id: "character-zheng-yuzhen",
    type: "character",
    title: "郑宇振 · 情感线",
    subtitle: "郑宇振",
    role: "情感线",
    summary:
      "静书年少时的朋友。他的出现像一面镜子，让静书重新看见了那个还没学会隐藏情绪的自己。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20an%20easygoing%20young%20man%20warm%20sunset%20light%20muted%20earth%20tones%20gentle%20smile%20film%20still%20portrait&width=900&height=1200&seq=mother3-char-05&orientation=portrait",
    date: "2026-09-09",
    tags: ["情感线", "故人", "回忆"],
    sections: [
      {
        heading: "人物设定",
        paragraphs: [
          "宇振是静书青春记忆里的一部分。他随性、松弛，与小镇上其他人的紧绷形成鲜明对比。",
          "他并不属于现在的静书，却让她想起了自己曾经的样子。",
        ],
      },
      {
        heading: "人物关系",
        paragraphs: [
          "他与静书的重逢，更多是一场关于“如果当初”的追问，也让观众思考选择与遗憾的意义。",
        ],
      },
    ],
  },
  {
    id: "character-xu-naying",
    type: "character",
    title: "徐娜英 · 支线人物",
    subtitle: "徐娜英",
    role: "支线人物",
    summary:
      "静书在城里工作时的好友，也是少数知道她全部经历的人。她代表着静书努力想要抓住的那部分新生活。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20confident%20modern%20young%20woman%20soft%20studio%20light%20clean%20warm%20neutral%20tones%20film%20still%20portrait&width=900&height=1200&seq=mother3-char-06&orientation=portrait",
    date: "2026-09-10",
    tags: ["支线", "友情", "新生活"],
    sections: [
      {
        heading: "人物设定",
        paragraphs: [
          "娜英是静书在城市里为数不多真正信任的人。她独立、清醒，总能在静书犹豫时给出最直接的建议。",
          "她的存在提醒观众，静书并不是孤立无援的，她一直都有可以依靠的朋友。",
        ],
      },
      {
        heading: "人物关系",
        paragraphs: [
          "通过电话与偶尔的见面，娜英把“城市”这条线索带进故事，也让静书在两个世界之间的摇摆更具体。",
        ],
      },
    ],
  },
  {
    id: "news-premiere-announcement",
    type: "news",
    title: "《年轻的母亲3》正式开播，温暖家庭叙事引发广泛期待",
    summary:
      "备受关注的系列新作《年轻的母亲3》正式上线。本季延续一贯细腻的家庭叙事风格，聚焦母女关系与故乡记忆。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20warm%20cozy%20living%20room%20with%20soft%20sunlight%20through%20curtains%20gentle%20domestic%20atmosphere%20muted%20warm%20tones%20film%20still&width=1200&height=800&seq=mother3-news-01&orientation=landscape",
    date: "2026-10-01",
    tags: ["开播", "官方", "动态"],
    sections: [
      {
        heading: "资讯详情",
        paragraphs: [
          "本季《年轻的母亲3》在延续系列一贯温情基调的同时，将叙事重心更多地放在了“回归”与“和解”上。故事从小城出发，用克制的镜头语言描绘一段普通家庭的重新相聚。",
          "制片方表示，本季希望探讨的是：当我们带着伤痕回到最初的地方，究竟能不能找到重新出发的勇气。",
        ],
      },
      {
        heading: "观众反馈",
        paragraphs: [
          "首播后，剧集细腻的情感处理与扎实的表演获得不少观众好评，尤其是母女线被认为“真实到让人不敢快进”。",
        ],
      },
    ],
  },
  {
    id: "news-creators-interview",
    type: "news",
    title: "主创深度访谈：如何塑造一个有血有肉的“母亲”",
    summary:
      "编剧与导演接受专访，分享了角色塑造背后的思考，以及他们对于“母亲”这一身份的理解。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20empty%20interview%20room%20with%20two%20chairs%20and%20warm%20soft%20lighting%20clean%20minimal%20warm%20neutral%20tones%20editorial%20film%20still&width=1200&height=800&seq=mother3-news-02&orientation=landscape",
    date: "2026-10-04",
    tags: ["访谈", "主创", "幕后"],
    sections: [
      {
        heading: "资讯详情",
        paragraphs: [
          "在采访中，编剧坦言，创作的起点并不是“母亲应该是什么样”，而是“一个人可以怎样笨拙地爱着另一个人”。正是这个视角，让剧中的母亲摆脱了刻板印象。",
          "导演则分享了拍摄中对留白的坚持，认为“观众需要空间去感受，而不是被台词填满”。",
        ],
      },
      {
        heading: "亮点摘录",
        paragraphs: [
          "“我们想拍的不是一个完美的母亲，而是一个还在学习怎么去爱的普通人。”",
        ],
      },
    ],
  },
  {
    id: "news-ratings-buzz",
    type: "news",
    title: "收视与口碑双丰收，网友热议人物成长线",
    summary:
      "随着剧情推进，《年轻的母亲3》热度持续走高，关于人物成长与选择的讨论成为社交平台热门话题。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20warm%20evening%20city%20living%20room%20glowing%20tv%20screen%20soft%20ambient%20light%20cozy%20muted%20warm%20tones%20film%20still&width=1200&height=800&seq=mother3-news-03&orientation=landscape",
    date: "2026-10-06",
    tags: ["口碑", "热议", "收视"],
    sections: [
      {
        heading: "资讯详情",
        paragraphs: [
          "播出过半后，剧集的口碑逐步走高。观众讨论最多的，是几位主要角色在面对过去时做出的不同选择。",
          "不少人表示，剧中没有绝对的好人与坏人，每个人都在用自己的方式笨拙地生活。",
        ],
      },
      {
        heading: "讨论焦点",
        paragraphs: [
          "第5集家宴一场戏被认为是“把中国式家庭拍得最准的一段”，相关片段在多个平台被反复分享。",
        ],
      },
    ],
  },
  {
    id: "news-behind-the-scenes",
    type: "news",
    title: "幕后花絮曝光：片场那些温柔的小时刻",
    summary:
      "官方释出最新幕后花絮，记录了演员们在片场相处的温暖日常，也让观众看到了角色之外的轻松一面。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20behind%20the%20scenes%20film%20set%20with%20softbox%20lights%20and%20camera%20warm%20neutral%20tones%20gentle%20candid%20atmosphere%20film%20still&width=1200&height=800&seq=mother3-news-04&orientation=landscape",
    date: "2026-10-08",
    tags: ["花絮", "片场", "幕后"],
    sections: [
      {
        heading: "资讯详情",
        paragraphs: [
          "本次公开的花絮纪录了演员们在拍摄间隙的日常：对戏、吃盒饭、在天台等日落。镜头之外，他们更像是一群相处融洽的朋友。",
          "片中扮演女儿的年轻演员在花絮里说，拍摄结束后她真的把剧中的长辈当成了家人。",
        ],
      },
      {
        heading: "精彩瞬间",
        paragraphs: [
          "天台那场戏的拍摄花絮尤其动人，剧组为等待完美的黄昏光线，连续拍了三个傍晚。",
        ],
      },
    ],
  },
  {
    id: "news-writer-on-ending",
    type: "news",
    title: "编剧解读结局：每一个选择都有它的重量",
    summary:
      "面对观众对结局的各种解读，编剧罕见地公开回应，讲述了他写作时想表达的核心主题。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20writing%20desk%20with%20notebook%20pen%20and%20warm%20desk%20lamp%20soft%20evening%20light%20intimate%20quiet%20muted%20warm%20tones%20film%20still&width=1200&height=800&seq=mother3-news-05&orientation=landscape",
    date: "2026-10-10",
    tags: ["结局", "解读", "主题"],
    sections: [
      {
        heading: "资讯详情",
        paragraphs: [
          "编剧表示，结局并不是要给观众一个标准答案，而是希望每个人都能够在其中找到属于自己的那一部分。",
          "“我不相信完美的结局，我更相信那些带着遗憾却依然愿意往前走的瞬间。”",
        ],
      },
      {
        heading: "创作手记",
        paragraphs: [
          "他透露，天台那一场戏的台词改了十几稿，最终决定用最简单的语言来完成这场情绪最重的对话。",
        ],
      },
    ],
  },
  {
    id: "news-soundtrack-release",
    type: "news",
    title: "配乐专辑正式上线，主题曲引发强烈情感共鸣",
    summary:
      "《年轻的母亲3》原声配乐专辑正式推出，收录音轨共十四首，主题曲上线后迅速获得大量听众推荐。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20headphones%20and%20vinyl%20player%20on%20warm%20wooden%20table%20soft%20window%20light%20cozy%20muted%20warm%20tones%20film%20still&width=1200&height=800&seq=mother3-news-06&orientation=landscape",
    date: "2026-10-12",
    tags: ["配乐", "主题曲", "原声"],
    sections: [
      {
        heading: "资讯详情",
        paragraphs: [
          "本季配乐延续了系列一贯的克制风格，大量使用钢琴与弦乐，为剧中的情绪留出呼吸的空间。",
          "主题曲以极简的编曲配合叙事化的歌词，被不少听众称为“听见就会想起天台那场戏”。",
        ],
      },
      {
        heading: "曲目亮点",
        paragraphs: [
          "专辑共收录十四首音轨，其中三首为剧中重要场景的特别版本，加入了环境声采样。",
        ],
      },
    ],
  },
];

export const categoryMeta = [
  {
    type: "plot",
    name: "剧情介绍",
    desc: "按集梳理《年轻的母亲3》的完整剧情脉络，从归乡到和解，逐集解析关键情节与人物动机。",
    icon: "ri-book-open-line",
  },
  {
    type: "character",
    name: "角色分析",
    desc: "深入解读剧中的主要角色，分析他们的性格、动机、关系与成长弧线，理解每一个选择的重量。",
    icon: "ri-user-heart-line",
  },
  {
    type: "news",
    name: "最新资讯",
    desc: "汇总《年轻的母亲3》的最新动态、官方消息、幕后花絮与主创访谈，第一时间掌握剧集相关资讯。",
    icon: "ri-newspaper-line",
  },
];